import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SupportButton from 'components/Shared/SupportButton';
import { ERROR_DURATION } from 'contexts/NotificationsProvider';
import {
  enqueueSnackbar,
  closeSnackbar,
  SNACKBAR_VARIANTS,
} from '../redux_store';
import { makeStyles } from '@material-ui/core';
import i18nInitialState from '../config/translations';
import PropTypes from 'prop-types';

function showServerError(dispatch, message, options, duration) {
  return dispatch(
    enqueueSnackbar({
      message: message || <_UnknownError options={options} />,
      options: {
        variant: SNACKBAR_VARIANTS.error,
        autoHideDuration: duration || ERROR_DURATION,
        action: options
          ? (key) => (
              <>
                <SupportButton options={options} />
                <IconButton
                  onClick={() => {
                    dispatch(closeSnackbar(key));
                  }}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </>
            )
          : undefined,
      },
    }),
  );
}

export default showServerError;

const useStyles = makeStyles((theme) => ({
  errorText: {
    color: theme.palette.error.light,
    fontSize: 14,
    fontWeight: '400',
  },
}));

const _UnknownError = ({ options }) => {
  const classes = useStyles();

  return (
    <div>
      <div>{i18nInitialState.en.errors.unknownError}</div>
      {options && (
        <div className={classes.errorText}>{i18nInitialState.en.general.pleaseContactUs}</div>
      )}
    </div>
  );
};

_UnknownError.propTypes = {
  options: PropTypes.shape({
    correlationUUID: PropTypes.string.isRequired,
    userUUID: PropTypes.string,
  }),
};

_UnknownError.defaultProps = {
  options: undefined,
};
